import { MarkdownContentPage } from "@/components/content/MarkdownContentPage";
import { contentPages } from "@/content/content-pages";

export default function BlogPage() {
  return <MarkdownContentPage content={contentPages.blog} />;
}
